import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { LogoutButton, NavBar } from '../../../components/layout/NavBar'
import { Services } from '@/services/services'
import { useNavigate, useParams } from 'react-router-dom'

import './Dashboard.module.css'
import { callMeBtn } from '@/components/Elements/CallMeBtn'
import { CurrentSession } from '@/services/repository/session'
import { LoggedInLayout } from '@/components/layout/LoggedInLayout'
import { UserLangsButton } from '@/components/layout/Langs'


export const UserDashboard = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const { translates } = session
  const navigate = useNavigate()
  let lang = useParams().lang

  return <LoggedInLayout pageName='dashboard' services={services} session={session}
    navbarLeft={<LogoutButton services={services} translates={translates} />}
    navbarRight={<UserLangsButton session={session} services={services} translates={translates} />}  >
    {/* <a className='main-btn' onClick={() => navigate('/communal/qrscanner')}>
      {translates.for('menu.qrscanner')}
    </a> */}
    <a className='main-red-btn' onClick={() => navigate('/communal/qrscanner')}>
      {translates.for('menu.qrscanner')}
    </a>
    <a className='main-btn' onClick={() => navigate('/communal/my/machines')}>
      {translates.for('menu.my_machines')}
    </a>
    <a className='main-btn' onClick={() => navigate('/communal/my/failures/map')}>
      {translates.for('menu.failures_map')}
    </a>
    <a className='main-btn' onClick={() => navigate('/communal/my/hit/map')}>
      {translates.for('menu.hit_map')}
    </a>
    <a className='main-btn' onClick={() => navigate('/communal/my/battery/map')}>
      {translates.for('menu.battery_map')}
    </a>
    <a className='main-btn' onClick={() => navigate('/communal/my/map')}>
      {translates.for('menu.map')}
    </a>
    <a className='main-green-btn' onClick={() => navigate('/communal/support/wizard')}>
      {translates.for('menu.support_questions')}
    </a>
    <a className='main-rgreen-btn' onClick={() => navigate('/communal/contact')}>
      {translates.for('menu.contact')}
    </a>
  </LoggedInLayout>
};
